import styles from './Footer.module.css';

export function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.top}>
          <p className={styles.copyright}>
            &copy; {new Date().getFullYear()} Norion. Все права защищены.
          </p>

          <span className={styles.brand}>Powered by Norion</span>
        </div>

        <div className={styles.legal}>
          <div className={styles.legalSection}>
            <h4 className={styles.legalTitle}>Описание услуг</h4>
            <p className={styles.legalText}>
              Norion — сервис повышения безопасности и конфиденциальности сетевого соединения.
              Обеспечивает шифрование интернет-трафика и защиту персональных данных
              при использовании публичных и частных сетей. Подписка от 125 &#8381;/мес.
              Доступен бесплатный ознакомительный период.
            </p>
          </div>

          <div className={styles.legalSection}>
            <h4 className={styles.legalTitle}>Оферта</h4>
            <p className={styles.legalText}>
              Оплата подписки является акцептом настоящей оферты. Услуги предоставляются
              на условиях «как есть» в соответствии с выбранным тарифным планом.
              Возврат средств осуществляется в течение 3 (трёх) календарных дней с момента
              оплаты при условии отсутствия факта использования услуги.
              Исполнитель оставляет за собой право ограничить доступ к сервису
              в случае нарушения пользователем применимого законодательства
              или условий настоящей оферты. Исполнитель не контролирует и не несёт
              ответственности за содержание ресурсов, доступ к которым осуществляется
              с использованием сервиса.
            </p>
          </div>

          <div className={styles.legalSection}>
            <h4 className={styles.legalTitle}>Реквизиты</h4>
            <p className={styles.legalText}>
              Нор Никита Вячеславович, самозанятый<br />
              ИНН: 563902346780<br />
              Контакт: nor.nikit@yandex.ru
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
